import { API } from 'services'

export function getCompanyIntegration() {
  return API({
    endpoint: '/company-integration',
  })
}

export function updateCompanyIntegration(params) {
  return API({
    method: 'PUT',
    endpoint: '/company-integration',
    ...params,
  })
}
